import React from 'react';
import { Base, Skeleton } from 'lib/cortiUI';
export const QuestionsLoader = () => {
    return (React.createElement(Base, { display: "flex", flexDirection: "column", gap: 5 }, Array.from({ length: 10 }, (_, idx) => (React.createElement(Skeleton, { key: idx, variant: "rounded", width: "100%", height: 150 })))));
};
